import React, { useEffect, useState } from 'react'
import './digital-vault-companies.css'

import { GridSelectionHLPure, ListViewPure, SearchBarHLPure, SimpleLoading } from '../../pures'
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import { filterBy, orderBy } from '@progress/kendo-data-query'
import { changeFormatNumberToShow } from '../../../utils'
import ViewType from '../digital-vault/viewType'
import { useTranslation } from 'react-i18next'

const initialSort = [
    {
        field: 'company.companyName',
        dir: 'asc',
    },
]

const initialFilter = {
    logic: 'and',
    filters: [
        {
            field: 'company.companyName',
            operator: 'contains',
            value: '',
        },
    ],
}

const getStatusByCompliance = (compliance, obligatoryDocCount) => {
    compliance = parseInt(compliance)
    if (compliance == 100) {
        return 'green'
    }
    if ((compliance >= 0 && compliance < 80) && obligatoryDocCount > 0) {
        return 'red'
    } else if (compliance == 0 && obligatoryDocCount === 0) {
        return ''
    } else {
        return 'yellow'
    }
}

const DigitalVaultCompanyCard = (props) => {
    const {
        dataItem,
        onClick,
        t
    } = props


    const documents = dataItem.documents
    const company = dataItem.company
    const color = getStatusByCompliance(documents.percent, documents.obligatory)

    return (
        <button className='digitalVaultCompanyCard' onClick={() => onClick(dataItem)}>
            <img className='digitalVaultCompanyCard-img' src={company.logo || 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Group.svg'} alt={company.companyName} />
            <div className='digitalVaultCompanyCard-info'>
                <p className='digitalVaultCompanyCard-company'>{company.companyName} <span className={`digitalVault-compliance ${color}`}></span></p>
                <table className='digitalVaultCompanyCard-data'>
                    <tbody>
                        <tr>
                            <th>{t('digitalVaultCompanyCard.compliance')}</th>
                            <td>{changeFormatNumberToShow(documents.upload, 5)}/{changeFormatNumberToShow(documents.obligatory, 5)}</td>
                        </tr>
                        <tr>
                            <th>{t('digitalVaultCompanyCard.total.docs')}</th>
                            <td>{changeFormatNumberToShow(documents.total, 5)}</td>
                        </tr>
                        <tr>
                            <th>{t('digitalVaultCompanyCard.total.exp')}</th>
                            <td>{changeFormatNumberToShow(documents.folders, 5)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </button>
    )
}

const CellColumnOne = (props) => {
    const {
        dataItem,
        onClick,
    } = props

    const company = dataItem.company

    return (
        <td onClick={() => onClick(dataItem)} className='digitalVaultCompaniesView-col1'>
            <div className='digitalVaultCompaniesView-col1-content'>
                <img
                    alt='profile-img'
                    src={company.logo || 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Group.svg'}
                    className='digitalVaultCompaniesView-col1-avatar'
                />
                <p className='digitalVaultCompaniesView-col1-name'>{company.companyName}</p>
            </div>
        </td>
    )
}

const CellColumnStatus = (props) => {
    const {
        dataItem,
        onClick,
    } = props

    const color = getStatusByCompliance(dataItem.documents.percent, dataItem.documents.obligatory)

    return (
        <td onClick={() => onClick(dataItem)} className='digitalVaultCompaniesView-colStatus'>
            <div className='digitalVaultCompaniesView-colStatus-content'>
                <span className={`digitalVault-compliance ${color}`}></span>
            </div>
        </td>
    )
}

const CellColumnNumber = (props) => {
    const {
        dataItem,
        onClick,
        column,
    } = props

    const documents = dataItem.documents

    let content = null

    switch (column) {
        case 2:
            content = <p>{changeFormatNumberToShow(documents.upload, 5)}/{changeFormatNumberToShow(documents.obligatory, 5)}</p>
            break
        case 3:
            content = <p>{changeFormatNumberToShow(documents.total, 5)}</p>
            break
        case 4:
            content = <p>{changeFormatNumberToShow(documents.folders, 5)}</p>
            break
    }

    return (
        <td className={`digitalVaultCompaniesView-colNumber`} onClick={() => onClick(dataItem)} >
            <div className={`digitalVaultCompaniesView-colNumber-content`}>
                {content}
            </div>
        </td>
    )
}

const DigitalVaultCompaniesView = (props) => {
    const {
        isLoading,
        viewAsCards,
        setViewAsCards,
        companies,
        setSelectedCompany,
    } = props

    const { t } = useTranslation()

    const [companySearch, setCompanySearch] = useState('')
    const [filter, setFilter] = useState(initialFilter)
    const [sort, setSort] = useState(initialSort)
    const [companiesGrid, setCompaniesGrid] = useState(companies)
    const pageable = companies.length < 28

    useEffect(() => {
        setCompaniesGrid(companies)
    }, [companies])

    useEffect(() => {
        setFilter({
            logic: 'and',
            filters: [
                {
                    field: 'company.companyName',
                    operator: 'contains',
                    value: companySearch,
                },
            ],
        })
    }, [companySearch])

    const CompanyCard = (props) => <DigitalVaultCompanyCard {...props} t={t} onClick={setSelectedCompany} />

    const showShortDocumentHeader = useMediaQuery('(max-width:1180px)')
    const hideDocuments = useMediaQuery('(max-width:1000px)')
    const hideReports = useMediaQuery('(max-width:820px)')
    const hideCompliance = useMediaQuery('(max-width:620px)')
    const hideStatusTitle = useMediaQuery('(max-width:520px)')

    const CompanyColumnOne = (props) => <CellColumnOne {...props} onClick={setSelectedCompany} />
    const CompanyColumnStatus = (props) => <CellColumnStatus {...props} onClick={setSelectedCompany} />
    const CompanyColumnTwo = (props) => <CellColumnNumber {...props} column={2} onClick={setSelectedCompany} />
    const CompanyColumnThree = (props) => <CellColumnNumber {...props} column={3} onClick={setSelectedCompany} />
    const CompanyColumnFour = (props) => <CellColumnNumber {...props} column={4} onClick={setSelectedCompany} />

    if (isLoading) return <SimpleLoading />

    return (
        <Container disableGutters className='digitalVaultCompaniesView'>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Grid container className={`digitalVaultView-filters ${viewAsCards ? 'adjust' : null}`}>
                        <span aria-hidden='true' className='hidden'></span>
                        <Grid item>
                            <SearchBarHLPure
                                placeholder={t('digitalVaultCompaniesView.placeholder.search')}
                                searchValue={companySearch}
                                onSearchChange={(e) => setCompanySearch(e.target.value)}
                            />
                        </Grid>
                        <ViewType viewAsCards={viewAsCards} setViewAsCards={setViewAsCards} />
                    </Grid>
                </Grid>
                <Grid item xs={12} className={`digitalVaultView-data ${pageable ? null : 'scroll'}`}>
                    {
                        viewAsCards
                            ? <ListViewPure
                                data={filterBy(orderBy(companiesGrid, sort), filter)}
                                pageable={pageable}
                                take={6}
                                itemRendered={CompanyCard}
                                listClassName='digitalVaultView-cardView'
                                pagerClassName='digitalVaultView-cardView-pager'
                            />
                            : <GridSelectionHLPure
                                skip={0}
                                take={6}
                                pageable={pageable}
                                dataGrid={filterBy(orderBy(companiesGrid, sort), filter)}
                                sortable={true}
                                sort={sort}
                                onSortChange={(e) => {
                                    setSort(e.sort)
                                }}
                                onRowClick={setSelectedCompany}

                                titleRow1={t('digitalVaultCompaniesView.grid.title.1')}
                                cellColumnOne={CompanyColumnOne}
                                isCheckedColOne={'company.companyName'}
                                headerColumnOneClass={'digitalVaultCompaniesView-col1'}

                                statusColumn
                                titleStatusColumn={hideStatusTitle ? '' : t('digitalVaultCompaniesView.grid.title.2')}
                                cellColumnStatus={CompanyColumnStatus}
                                headerColumnStatusClass={'digitalVaultCompaniesView-colStatus'}

                                columnTwo={!hideCompliance}
                                titleRow2={t('digitalVaultCompaniesView.grid.title.3')}
                                cellColumnTwo={CompanyColumnTwo}
                                headerColumnTwoClass={'digitalVaultCompaniesView-colNumber'}

                                columnThree={!hideDocuments}
                                titleRow3={showShortDocumentHeader ? t('digitalVaultCompaniesView.grid.title.short.4') : t('digitalVaultCompaniesView.grid.title.4')}
                                cellColumnThree={CompanyColumnThree}
                                headerColumnThreeClass={'digitalVaultCompaniesView-colNumber'}

                                columnFour={!hideReports}
                                titleRow4={showShortDocumentHeader ? t('digitalVaultCompaniesView.grid.title.short.5') : t('digitalVaultCompaniesView.grid.title.5')}
                                cellColumnFour={CompanyColumnFour}
                                headerColumnFourClass={'digitalVaultCompaniesView-colNumber'}
                            />
                    }
                </Grid>
            </Grid>
        </Container>
    )
}

export default DigitalVaultCompaniesView